export default "__VITE_ASSET__PKLRQcYT__"